import React from 'react';
import PropTypes from 'prop-types';
import {Button} from 'semantic-ui-react';
import {FormattedMessage} from "react-intl";
import {formatDate, isNoU} from "utils/DBUtils";
import ItemInfoGroup from "components/common/ItemInfoGroup";
import ResourceFormProxy from "../../../classes/ResourceFormProxy";

{/* We need a custom component to upload a csv and make the call
  to import the locations */
}
const StoreLocationImporter = (props) => {
    let file = props.formProxy.currentResource.storeLocationFile;
    let hasFile = !isNoU(file);
    let hasClient = !isNoU(props.formProxy.currentResource.client) && props.formProxy.currentResource.client.trim() !== "";
    let hasUpload = !isNoU(props.upload);

    let uploadButton = (
        <Button className="blue" onClick={props.onClick}>
            <FormattedMessage id='editbreak.steps.store_finder.upload_locations'/>
        </Button>
    );
    let child = "";
    if (!hasUpload && !hasFile) {
        child = uploadButton;
    } else if (hasUpload || hasFile) { // have file

        let header = "";
        let description = "";
        let items = [];
        let className = "";
        let animationType;
        let isError = false;

        // Use file first if exists
        if (hasFile) {
            header = file.originalFilename;
            description = <FormattedMessage id="editbreak.steps.store_finder.file_description" values={{
                date: formatDate(file._created),
                rowCount: file.totalRows
            }}/>;
            items.push(file);
        } else {
            header = props.upload.params.originalFilename;
            description = <FormattedMessage
                id={`editbreak.steps.store_finder.status_message.${props.upload.status.toLowerCase()}`}/>;
            items.push(props.upload);

            if (props.upload.status === "ERROR") {
                className = "error";
                animationType = "Error";
                description = props.upload.errorMsg;
                isError = true;
            }
        }

        console.log('is error', isError);

        child = (
            <React.Fragment>
                {isError ? uploadButton : ""}
                <ItemInfoGroup className={className}
                               animationType={animationType}
                               onRemoveClick={hasFile ? () => props.removeLocations(file) : undefined}
                               items={items}
                               itemDetails={[
                                   {
                                       header: header,
                                       description: description
                                   }
                               ]}/>
            </React.Fragment>
        )
    }

    return (
        <div className="store-location-importer">
            {child}
        </div>
    );
};

StoreLocationImporter.propTypes = {
    onUploadClick: PropTypes.func.isRequired,
    formProxy: PropTypes.instanceOf(ResourceFormProxy).isRequired,
    upload: PropTypes.object
};

export default StoreLocationImporter;



// WEBPACK FOOTER //
// ./public/components/forms/CustomFields/StoreLocationImporter.jsx